var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('b-form-input',{attrs:{"placeholder":_vm.placeholder},on:{"change":_vm.handleChangeValue},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }